<template>
	<div class="page1_main_layout_phone">
		<el-carousel height="220px" trigger="click" motion-blur arrow="always" indicator-position="outside"
			:autoplay="false">
			<el-carousel-item>
				<div class="page1_carousel_content page1_carousel_content_img_1">

				</div>
			</el-carousel-item>
			<!-- 					<el-carousel-item >
						<div class="page1_carousel_content page1_carousel_content_img_2">
							
						</div>
		
					</el-carousel-item> -->
			<el-carousel-item>
				<div class="page1_carousel_content page1_carousel_content_img_3">

				</div>

			</el-carousel-item>
			<el-carousel-item>
				<div class="page1_carousel_content page1_carousel_content_img_4">

				</div>

			</el-carousel-item>
		</el-carousel>
		<div class="core_advantages_layout">

			<div class="core_advantages_title">
				核心优势
			</div>
			<div class="core_advantages_item">
				<div class="core_advantages_item_icon core_advantages_item_icon_1">

				</div>
				<div class="core_advantages_item_title">
					独家算法
				</div>
				<div class="core_advantages_item_text">
					公司研发的一套独家算法融合了国内领先的高性能自主算法结构与前沿AI模型，为检测领域带来全新突破。这套算法在检测精度上表现卓越，可达到±5um同时把误差率控制在1%以内，达到业界先进水平。该算法不仅大幅提升了检测环节的工作效率，也凭借高精准度降低了次品率，从而为企业节省生产成本，显著增强市场竞争力，在推动行业技术进步的道路上迈出重要一步。
				</div>

			</div>
			<div class="core_advantages_item">
				<div class="core_advantages_item_icon core_advantages_item_icon_2">

				</div>
				<div class="core_advantages_item_title">
					软件
				</div>
				<div class="core_advantages_item_text">
					公司完全自主研发，拥有独立的知识产权，软件界面简洁、功能强大，涵盖了行业内常见的多种核心功能，并且在深度和广度上都远超同类产品。无论是数据处理、图像识别、系统控制还是其他复杂任务，我们的软件都能快速、准确地完成，为用户提供卓越的使用体验。此外我们的软件实行单客定制更契合用户需求，支持多平台、多接口交互助力企业构建完整的信息化生态系统。软件从底层架构到上层应用都经过了反复的设计、开发和测试，确保了其稳定性和可靠性。
				</div>

			</div>
			<div class="core_advantages_item">
				<div class="core_advantages_item_icon core_advantages_item_icon_3">

				</div>
				<div class="core_advantages_item_title">
					相机
				</div>
				<div class="core_advantages_item_text">
					搭载 2000 万至 4300
					万像素高分辨率数字相机。该相机具备卓越的全视野成像能力，在实现清晰成像的同时，将畸变控制在超低水平。其凭借出色的抗干扰性能，在复杂的工业环境下，也能稳定采集高质量图像，可广泛应用于各类工业检测、机器视觉识别等领域。
				</div>

			</div>
			<div class="core_advantages_item">
				<div class="core_advantages_item_icon core_advantages_item_icon_4">

				</div>
				<div class="core_advantages_item_title">
					镜头
				</div>
				<div class="core_advantages_item_text">
					选用的镜头拥有极高的解像力，不仅确保画面中心清晰锐利，而且画面边缘的清晰度与之保持高度一致，实现近乎零畸变的成像效果。同时，镜头具备卓越的抗震、高低温性能，能够在恶劣的物理环境下，始终保持稳定的成像质量。
				</div>

			</div>
			<div class="core_advantages_item">
				<div class="core_advantages_item_icon core_advantages_item_icon_5">

				</div>
				<div class="core_advantages_item_title">
					光源
				</div>
				<div class="core_advantages_item_text">
					采用准平行光源设计，配置进口多色 LED 颗粒。这种光源能够有效解决产品大面积反光的难题，且光源的衰减漂移极小。经过严格的寿命测试，其理论使用寿命可达 3
					年以上，极大地降低了维护成本。此外，光源稳定性强，校正周期长，可实现半年乃至一年校正一次。
				</div>

			</div>
			<div class="core_advantages_item">
				<div class="core_advantages_item_icon core_advantages_item_icon_6">

				</div>
				<div class="core_advantages_item_title">
					定制化
				</div>
				<div class="core_advantages_item_text">
					设备定制化具有多方面优势，主要体现在以下几个方面：贴合独特生产流程、满足特殊环境要求、实现个性化功能需求、提高生产效率、降低生产成本、优化产品质量、增强企业竞争力等。
					企业在定制设备后可按企业生产节拍与产能设计，实现自动化与智能化生产，减少人工干预，提高生产速度与质量稳定性以及提升品牌形象展示企业对生产的专注与专业，以及对产品质量的严格要求，有助于提升品牌形象与市场认可度，增强客户信任。
				</div>

			</div>
		</div>

		<div class="show_industry_applications_layout" style="display: none;">
			<div class="show_industry_applications_title">
				用人工智能释放数据价值 视觉检测落地千行百业
			</div>
			<div class="show_industry_applications_title_2">
				为消费电子、半导体、汽车、新能源、食品医药、零售、物流等多个行业提供方案
			</div>

			<!-- 			<div class="show_industry_application_item_layout"
			>
				<div class="show_industry_application_item_img page7_main_content_img_0" >
					<div class="show_industry_application_item_text">
						sssssssssss
					</div>
				</div>
			</div> -->
			<div class="show_industry_application_item_layout" v-for="(item, key) in product_list_data_4" :key="key"
				@click="choose_app_item(key)">
				<div class="show_industry_application_item_text">
					{{ item.title }}
				</div>
				<div class="show_industry_application_item_img page7_main_content_img_0" v-show="key == 0">

				</div>
				<div class="show_industry_application_item_img page7_main_content_img_1_2" v-show="key == 1">
					<!-- 					<div class="show_industry_application_item_text">
						{{item.title}}
					</div> -->
				</div>
				<div class="show_industry_application_item_img page7_main_content_img_2" v-show="key == 2">
					<!-- 					<div class="show_industry_application_item_text">
						{{item.title}}
					</div> -->
				</div>
				<div class="show_industry_application_item_img page7_main_content_img_3" v-show="key == 3">
					<!-- 					<div class="show_industry_application_item_text">
						{{item.title}}
					</div> -->
				</div>
				<div class="show_industry_application_item_img page7_main_content_img_4" v-show="key == 4">
					<!-- 					<div class="show_industry_application_item_text">
						{{item.title}}
					</div> -->
				</div>
				<div class="show_industry_application_item_img page7_main_content_img_5" v-show="key == 5">
					<!-- 					<div class="show_industry_application_item_text">
						{{item.title}}
					</div> -->
				</div>
				<div class="show_industry_application_item_img page7_main_content_img_6" v-show="key == 6">
					<!-- 					<div class="show_industry_application_item_text">
						{{item.title}}
					</div> -->
				</div>
			</div>
		</div>

		<div class="page_new_content_1" v-show="false">
			<div class="page_new_content_item" @click="click_one_menu_phone('page2', 1)">
				<!-- <div class="show_api_list" >
							<div class="show_api_list_layout">
								<div class="show_api_list_item"  @click="show_one_product('1_'+item.id)" v-for="item in product_list_data_1">
									{{item.title}}
								</div>
							</div>
					
						</div> -->

				<div class="page_new_content_item_title">
					<div class="page_new_content_item_title_icon page_new_content_item_title_icon_1"></div>
					智能设备
				</div>
				<div class="page_new_content_item_img page_new_content_list_item_img_1">

				</div>
			</div>

			<div class="page_new_content_item" style="margin-left: 0px;" @click="click_one_menu_phone('page2', 2)">
				<!-- <div class="show_api_list" >
							<div class="show_api_list_layout">
								<div class="show_api_list_item"  @click="show_one_product('2_'+item.id)" v-for="item in product_list_data_2">
									{{item.title}}
								</div>
							</div>
					
						</div> -->
				<div class="page_new_content_item_title">
					<div class="page_new_content_item_title_icon page_new_content_item_title_icon_2"></div>
					软件系统
				</div>
				<div class="page_new_content_item_img page_new_content_list_item_img_2">

				</div>
			</div>

			<div class="page_new_content_item" @click="click_one_menu_phone('page2', 3)">
				<!-- <div class="show_api_list" >
							<div class="show_api_list_layout">
								<div class="show_api_list_item"  @click="click_one_api_btn(item.id)" v-for="item in api_list_data">
									{{item.title}}
								</div>
							</div>
					
						</div> -->
				<div class="page_new_content_item_title">
					<div class="page_new_content_item_title_icon page_new_content_item_title_icon_3"></div>
					软件定制
				</div>
				<div class="page_new_content_item_img page_new_content_item_img_api">

				</div>
			</div>

			<div class="page_new_content_item" style="margin-left: 0px;" @click="click_one_menu_phone('page3', 1)">
				<!-- <div class="show_api_list" >
							<div class="show_api_list_layout">
								<div class="show_api_list_item"  @click="show_one_product('4_'+item.id)" v-for="item in product_list_data_3">
									{{item.title}}
								</div>
							</div>
					
						</div> -->
				<div class="page_new_content_item_title">
					<div class="page_new_content_item_title_icon page_new_content_item_title_icon_4"></div>
					项目案例
				</div>
				<div class="page_new_content_item_img page_new_content_list_item_img_3">

				</div>
			</div>
		</div>
	</div>
	<div class="page1_main_layout">
		<!-- height="450px"  -->

		<div class="hero">
			<div class="container">
				<div class="hero-content">
					<div class="hero-text">
						<h1>引领科技创新，塑造智能未来</h1>
						<p>我们提供尖端的设备和软件解决方案，助力企业实现数字化转型，提升核心竞争力。</p>
						<div class="hero_btn_box">
							<a href="#" class="hero_btn_box_btn_1" @click="goto_product">探索产品</a>
							<a href="#" class="hero_btn_box_btn_2" @click="goto_contact">联系我们</a>
						</div>

					</div>
					<div class="hero-image">
						<div class="tech-circle">
							<div class="tech-core"></div>
							<div class="tech-dot"></div>
							<div class="tech-dot"></div>
							<div class="tech-dot"></div>
							<div class="tech-dot"></div>
						</div>
					</div>
				</div>
			</div>
		</div>


		<el-carousel height="600px" trigger="click" motion-blur arrow="always" :autoplay="false" style="display: none;">
			<el-carousel-item>
				<div class="page1_carousel_content page1_carousel_content_img_1">
					<!-- <div style="
								position: absolute;
								left: 400px;
								color: #ffffff;
								font-size: 60px;
								top: 250px;
								font-weight: 600;
								
								">
								持续创新 | 卓越经营
							</div>
							<div style="
								position: absolute;
								left: 260px;
								color: #ffffff;
								font-size: 40px;
								top: 350px;
								font-weight: 600;
								
								">
								为客户提供满意、高品质的产品和高效技术服务
							</div> -->
				</div>
				<!-- 						<div class="page3_carousel_item page3_carousel_item_1" >
							
						</div> -->
			</el-carousel-item>
			<!-- 					<el-carousel-item >
						<div class="page1_carousel_content page1_carousel_content_img_2">
							
						</div>
					</el-carousel-item> -->

			<el-carousel-item>
				<div class="page1_carousel_content page1_carousel_content_img_3">
					<!-- 							<div style="
								position: absolute;
								right: 50px;
								color: #ffffff;
								font-size: 60px;
								top: 50px;
								font-weight: 600;
								
								">
								为工业视觉自动化领域提供一站式解决方案
							</div> -->

				</div>
				<!-- 					    <div class="page3_carousel_item page3_carousel_item_4" >
					    	
					    </div> -->
			</el-carousel-item>
			<el-carousel-item>
				<div class="page1_carousel_content page1_carousel_content_img_4">
					<!-- 							<div style="
								position: absolute;
								right: 50px;
								color: #ffffff;
								font-size: 45px;
								top: 50px;
								font-weight: 600;
								
								">
								视觉赋能，科研精准
							</div>
							<div style="
								position: absolute;
								right: 50px;
								color: #ffffff;
								font-size: 45px;
								top: 120px;
								font-weight: 600;
								
								">
								视觉把关，残次零藏
							</div>
							<div style="
								position: absolute;
								right: 50px;
								color: #ffffff;
								font-size: 45px;
								top: 190px;
								font-weight: 600;
								
								">
								 检测用视觉，良品率飞跃
							</div> -->
				</div>

			</el-carousel-item>
		</el-carousel>
		<div class="page_new_content_1">
			<div class="core_advantages_layout">

				<div class="core_advantages_title">
					核心优势
				</div>
				<div class="core_advantages_item">
					<div class="core_advantages_item_title">
						独家算法
					</div>
					<div class="core_advantages_item_text">
						<!-- 公司研发的一套独家算法融合了国内领先的高性能自主算法结构与前沿AI模型，为检测领域带来全新突破。这套算法在检测精度上表现卓越，可达到±5um同时把误差率控制在1%以内，达到业界先进水平。该算法不仅大幅提升了检测环节的工作效率，也凭借高精准度降低了次品率，从而为企业节省生产成本，显著增强市场竞争力，在推动行业技术进步的道路上迈出重要一步。 -->
						<ul>
							<li style="font-size: 18px;">
								公司自主研发的独家算法，融合高性能自主算法结构与前沿AI模型，实现检测领域技术突破。
							</li>
							<li style="font-size: 18px;">
								检测精度达±5um，误差率控制在1%以内，处于业界先进水平。
							</li>
							<li style="font-size: 18px;">
								显著提升检测效率，降低次品率，节省生产成本，增强市场竞争力。
							</li>
						</ul>

					</div>
					<div class="core_advantages_item_icon core_advantages_item_icon_1">

					</div>
				</div>
				<div class="core_advantages_item">
					<div class="core_advantages_item_title">
						软件
					</div>
					<div class="core_advantages_item_text">
						<!-- 公司完全自主研发，拥有独立的知识产权，软件界面简洁、功能强大，涵盖了行业内常见的多种核心功能，并且在深度和广度上都远超同类产品。无论是数据处理、图像识别、系统控制还是其他复杂任务，我们的软件都能快速、准确地完成，为用户提供卓越的使用体验。此外我们的软件实行单客定制更契合用户需求，支持多平台、多接口交互助力企业构建完整的信息化生态系统。软件从底层架构到上层应用都经过了反复的设计、开发和测试，确保了其稳定性和可靠性。 -->
						<ul>
							<li style="font-size: 18px;">
								完全自主研发，拥有独立知识产权。
							</li>
							<li style="font-size: 18px;">
								界面简洁、功能强大，覆盖行业核心功能，深度与广度远超同类产品。
							</li>
							<li style="font-size: 18px;">
								支持单客定制，多平台、多接口交互，助力企业构建信息化生态系统。
							</li>
							<li style="font-size: 18px;">
								从底层架构到应用层均经过反复测试，确保稳定可靠。
							</li>
						</ul>
					</div>
					<div class="core_advantages_item_icon core_advantages_item_icon_2">

					</div>
				</div>
				<div class="core_advantages_item">
					<div class="core_advantages_item_title">
						相机
					</div>
					<div class="core_advantages_item_text">
						<!-- 搭载 2000 万至 4300 万像素高分辨率数字相机。该相机具备卓越的全视野成像能力，在实现清晰成像的同时，将畸变控制在超低水平。其凭借出色的抗干扰性能，在复杂的工业环境下，也能稳定采集高质量图像，可广泛应用于各类工业检测、机器视觉识别等领域。 -->
						<ul>
							<li style="font-size: 18px;">
								搭载2000万至4300万像素高分辨率数字相机。
							</li>
							<li style="font-size: 18px;">
								全视野成像清晰，畸变极低，抗干扰能力强，适用于复杂工业环境。
							</li>
							<li style="font-size: 18px;">
								能稳定采集高质量图像，可广泛应用于各类工业检测、机器视觉识别等领域。
							</li>
						</ul>
					</div>
					<div class="core_advantages_item_icon core_advantages_item_icon_3">

					</div>
				</div>
				<div class="core_advantages_item">
					<div class="core_advantages_item_title">
						镜头
					</div>
					<div class="core_advantages_item_text">
						<!-- 选用的镜头拥有极高的解像力，不仅确画面中心清晰锐利，而且画面边缘的清晰度与之保持高度一致，实现近乎零畸变的成像效果。同时，镜头具备卓越的抗震、高低温性能，能够在恶劣的物理环境下，始终保持稳定的成像质量。 -->
						<ul>
							<li style="font-size: 18px;">
								具备极高解像力，画面中心与边缘清晰度一致，实现近乎零畸变。
							</li>
							<li style="font-size: 18px;">
								抗震、耐高低温，在恶劣环境下保持稳定成像质量。
							</li>
						</ul>
					</div>
					<div class="core_advantages_item_icon core_advantages_item_icon_4">

					</div>
				</div>
				<div class="core_advantages_item" style="margin-top: -50px;">
					<div class="core_advantages_item_title">
						光源
					</div>
					<div class="core_advantages_item_text">
						<!-- 采用准平行光源设计，配置进口多色 LED 颗粒。这种光源能够有效解决产品大面积反光的难题，且光源的衰减漂移极小。经过严格的寿命测试，其理论使用寿命可达 3 -->
						<!-- 年以上，极大地降低了维护成本。此外，光源稳定性强，校正周期长，可实现半年乃至一年校正一次。 -->
						<ul>
							<li style="font-size: 18px;">
								采用准平行光源设计，配置进口多色 LED 颗粒。
							</li>
							<li style="font-size: 18px;">
								有效解决大面积反光问题，衰减漂移极小，理论寿命达3年以上。
							</li>
							<li style="font-size: 18px;">
								稳定性强，校正周期长达半年至一年，降低维护成本。
							</li>
						</ul>
					</div>
					<div class="core_advantages_item_icon core_advantages_item_icon_5">

					</div>
				</div>
				<div class="core_advantages_item" style="margin-top: -50px;">
					<div class="core_advantages_item_title">
						定制化
					</div>
					<div class="core_advantages_item_text">
						<!-- 设备定制化具有多方面优势，主要体现在以下几个方面：贴合独特生产流程、满足特殊环境要求、实现个性化功能需求、提高生产效率、降低生产成本、优化产品质量、增强企业竞争力等。 -->
						<!-- 企业在定制设备后可按企业生产节拍与产能设计，实现自动化与智能化生产，减少人工干预，提高生产速度与质量稳定性以及提升品牌形象展示企业对生产的专注与专业，以及对产品质量的严格要求，有助于提升品牌形象与市场认可度，增强客户信任。 -->
						<ul>
							<li style="font-size: 18px;">
								贴合企业独特生产流程，满足特殊环境与个性化功能需求。
							</li>
							<li style="font-size: 18px;">
								提高生产效率，降低成本，优化产品质量，增强企业竞争力。
							</li>
							<li style="font-size: 18px;">
								支持自动化与智能化生产，减少人工干预，提升生产速度与质量稳定性。
							</li>

						</ul>
					</div>
					<div class="core_advantages_item_icon core_advantages_item_icon_6">

					</div>
				</div>
			</div>
		</div>
		<div class="page_new_content_1" v-show="false">
			<div class="page_new_content_item" style="margin-right: 40px;">
				<div class="show_api_list">
					<div class="show_api_list_layout">
						<div class="show_api_list_item" @click="show_one_product('1_' + item.id)"
							v-for="item in product_list_data_1">
							{{ item.title }}
						</div>
					</div>

				</div>

				<div class="page_new_content_item_title">
					<div class="page_new_content_item_title_icon page_new_content_item_title_icon_1"></div>
					智能设备
				</div>
				<div class="page_new_content_item_img page_new_content_list_item_img_1">

				</div>
			</div>

			<div class="page_new_content_item">
				<div class="show_api_list">
					<div class="show_api_list_layout">
						<div class="show_api_list_item" @click="show_one_product('2_' + item.id)"
							v-for="item in product_list_data_2">
							{{ item.title }}
						</div>
					</div>

				</div>
				<div class="page_new_content_item_title">
					<div class="page_new_content_item_title_icon page_new_content_item_title_icon_2"></div>
					软件系统
				</div>
				<div class="page_new_content_item_img page_new_content_list_item_img_2">

				</div>
			</div>

			<div class="page_new_content_item">
				<div class="show_api_list">
					<div class="show_api_list_layout">
						<div class="show_api_list_item" @click="click_one_api_btn(item.id)"
							v-for="item in api_list_data">
							{{ item.title }}
						</div>
					</div>

				</div>
				<div class="page_new_content_item_title">
					<div class="page_new_content_item_title_icon page_new_content_item_title_icon_3"></div>
					软件定制
				</div>
				<div class="page_new_content_item_img page_new_content_item_img_api">

				</div>
			</div>

			<div class="page_new_content_item" style="margin-right: 0px;">
				<div class="show_api_list">
					<div class="show_api_list_layout">
						<div class="show_api_list_item" @click="show_one_product('4_' + item.id)"
							v-for="item in product_list_data_3">
							{{ item.title }}
						</div>
					</div>

				</div>
				<div class="page_new_content_item_title">
					<div class="page_new_content_item_title_icon page_new_content_item_title_icon_4"></div>
					项目案例
				</div>
				<div class="page_new_content_item_img page_new_content_list_item_img_3">

				</div>
			</div>
			<!-- 			<div class="page_new_content_item" @click="show_one_product('1_'+item.id)" v-for="item in product_list_data_1" v-show="!item.unshow">
				<div class="page_new_content_item_title">
					{{item.title}}
				</div>
				<div :class="'page_new_content_item_img ' +  'page_new_content_item_img_' + item.id">
					
				</div>
			</div> -->


			<!-- <div class="page_new_content_item" @click="show_one_product('1_1')">
				<div class="page_new_content_item_title">
					AOI缺陷检测设备
				</div>
				<div class="page_new_content_item_img page_new_content_item_img_1">
					
				</div>
			</div>
			<div class="page_new_content_item"  @click="show_one_product('1_2')">
				
				<div class="page_new_content_item_title">
					FEP-光纤端面研磨机
				</div>
				<div class="page_new_content_item_img page_new_content_item_img_2">
					
				</div>
			</div>
			<div class="page_new_content_item" @click="show_one_product('1_3')">
				<div class="page_new_content_item_title">
					LAMS-激光器老化监控设备
				</div>
				<div class="page_new_content_item_img page_new_content_item_img_3">
					
				</div>
			</div> -->

			<!-- 			<div class="page_new_content_item"  @click="show_one_product('2_'+item.id)" v-for="item in product_list_data_2" v-show="!item.unshow">
				<div class="page_new_content_item_title">
					{{item.title}}
				</div>
				<div :class="'page_new_content_item_img ' +  'page_new_content_item_img_2_' + item.id">
					
				</div>
			</div> -->


			<!-- <div class="page_new_content_item"  @click="show_one_product('2_1')">
				<div class="page_new_content_item_title">
					电力应急设备库存跟踪监控
				</div>
				<div class="page_new_content_item_img page_new_content_item_img_4">
					
				</div>
			</div>
			<div class="page_new_content_item"  @click="show_one_product('2_2')" style="margin-right: 0px;">
				<div class="page_new_content_item_title">
					M2BA-M²分析仪 	
				</div>
				<div class="page_new_content_item_img page_new_content_item_img_5">
					
				</div>
			</div>
			<div class="page_new_content_item"  @click="show_one_product('2_3')">
				<div class="page_new_content_item_title">
					飞参识别系统
				</div>
				<div class="page_new_content_item_img page_new_content_item_img_6">
					
				</div>
			</div>
			<div class="page_new_content_item"  @click="show_one_product('2_4')">
				<div class="page_new_content_item_title">
					猫眼光纤识别
				</div>
				<div class="page_new_content_item_img page_new_content_item_img_7">
					
				</div>
			</div> -->

			<!-- 			<div class="page_new_content_item"  @click="show_one_product('4_'+item.id)" v-for="item in product_list_data_3" v-show="!item.unshow">
				<div class="page_new_content_item_title">
					{{item.title}}
				</div>
				<div :class="'page_new_content_item_img ' +  'case_img_' + item.id">
					
				</div>
			</div> -->

			<!-- 
			<div class="page_new_content_item"  @click="show_one_product('4_1')">
				<div class="page_new_content_item_title">
					AI识别预警系统
				</div>
				<div class="page_new_content_item_img case_img_1">
					
				</div>
			</div>
			<div class="page_new_content_item"  @click="show_one_product('4_2')">
				<div class="page_new_content_item_title">
					车辆智能管理系统
				</div>
				<div class="page_new_content_item_img case_img_2">
					
				</div>
			</div>
			<div class="page_new_content_item"  @click="show_one_product('4_3')" style="margin-right: 0px;">
				<div class="page_new_content_item_title">
					智能巡检机器人
				</div>
				<div class="page_new_content_item_img case_img_3">
					
				</div>
			</div> -->


		</div>
		<div class="show_industry_applications_layout">
			<div class="show_industry_applications_title">
				用人工智能释放数据价值 视觉检测落地千行百业
			</div>
			<div class="show_industry_applications_title_2">
				为消费电子、半导体、汽车、新能源、食品医药、零售、物流等多个行业提供方案
			</div>
			<div class="show_industry_application_item_layout" v-for="(item, key) in product_list_data_4" :key="key"
				@click="choose_app_item(key)">
				<div class="show_industry_application_item_img page7_main_content_img_0" v-show="key == 0">
					<div class="show_industry_application_item_text">
						{{ item.title }}
					</div>
				</div>
				<div class="show_industry_application_item_img page7_main_content_img_1_2" v-show="key == 1">
					<div class="show_industry_application_item_text">
						{{ item.title }}
					</div>
				</div>
				<div class="show_industry_application_item_img page7_main_content_img_2" v-show="key == 2">
					<div class="show_industry_application_item_text">
						{{ item.title }}
					</div>
				</div>
				<div class="show_industry_application_item_img page7_main_content_img_3" v-show="key == 3">
					<div class="show_industry_application_item_text">
						{{ item.title }}
					</div>
				</div>
				<div class="show_industry_application_item_img page7_main_content_img_4" v-show="key == 4">
					<div class="show_industry_application_item_text">
						{{ item.title }}
					</div>
				</div>
				<div class="show_industry_application_item_img page7_main_content_img_5" v-show="key == 5">
					<div class="show_industry_application_item_text">
						{{ item.title }}
					</div>
				</div>
				<div class="show_industry_application_item_img page7_main_content_img_6" v-show="key == 6">
					<div class="show_industry_application_item_text">
						{{ item.title }}
					</div>
				</div>
			</div>
		</div>

		<div class="page1_main_layout_2" v-if="false">
			<div class="page1_main_layout_3">
				<div class="page1_sub page1_sub_1">
					<div class="page1_sub_1_title" @mouseover="handle_title_MouseOver(1)">
						<div class="sub_title_icon sub_title_icon_1"
							style="margin-top: calc(((100vh - var(--main_header_height) - 100px - 70px)/2) + 40px )">
						</div>
						<div class="sub_title_content"
							style="margin-top: calc(((100vh - var(--main_header_height) - 100px - 70px)/2) - 40px )">
							关于我们
						</div>
						<div class="sub_title_text" style="display: none;">
							致力于机器视觉，人工智能方案，自动化设备研发生产及系统集成
						</div>
						<div class="sub_title_line"></div>
					</div>
					<div class="page1_sub_1_content_layout">
						<div class="sub_1_content_1">
							致力于机器视觉，人工智能方案，自动化设备研发生产及系统集成
						</div>
						<div class="sub_1_content_show_img_layout">
							<div class="sub_1_content_show_img_layout_2">
								<div class="sub_1_content_show_img sub_1_content_show_img_1"></div>

								<div class="sub_1_content_show_img sub_1_content_show_img_3"></div>
								<div class="sub_1_content_show_img sub_1_content_show_img_4"></div>
								<div class="sub_1_content_show_img sub_1_content_show_img_2"></div>
							</div>
						</div>
						<div class="sub_1_content_2">
							武汉为之易科技有限公司作为技术创新驱动的企业，汇聚了一批专业素质高、创新能力强劲、实践经验丰富的研发团队。我们不断推动技术进步，研发了系列先进、可靠的设备，以应对市场的变化。我司的系统方案和产品覆盖了光电行业、新能源行业、电子行业等多个领域，从基础模块到系统集成，全方位满足客户需求。

						</div>
						<div class="sub_1_btn" @click="handle_btn_to_index(1)">
							了解更多...
						</div>
					</div>
				</div>
				<div class="page1_sub page1_sub_2">
					<div class="page1_sub_2_title" @mouseover="handle_title_MouseOver(2)">
						<div class="sub_title_icon sub_title_icon_2"></div>
						<div class="sub_title_content">
							智能硬件
						</div>
						<div class="sub_title_text">
							AOI缺陷检测设备、FEP-光纤端面研磨机、LAMS-激光器老化监控设备...
						</div>
						<div class="sub_title_line" style="display: none;"></div>
					</div>
					<div class="page1_sub_1_content_layout">
						<div class="sub_2_content_1">

						</div>
						<div class="sub_1_btn" @click="handle_btn_to_index(2)">
							了解更多...
						</div>
					</div>
				</div>
				<div class="page1_sub page1_sub_3">
					<div class="page1_sub_3_title" @mouseover="handle_title_MouseOver(3)">
						<div class="sub_title_icon sub_title_icon_3"></div>
						<div class="sub_title_content">
							软件产品
						</div>
						<div class="sub_title_text">
							提供各种实用功能接口及定制化系统开发服务
						</div>
						<div class="sub_title_line" style="display: none;"></div>
					</div>
					<div class="page1_sub_1_content_layout">
						<div class="sub_3_content_list_layout">
							<div class="sub_3_content_list_item" v-for="item in api_list_data"
								@click="click_one_btn(item)">
								<!-- {{i}} -->
								<div :class="'sub_3_content_list_item_img ' + 'api_show_img_' + item.id">

								</div>
								<div class="sub_3_content_list_item_text">
									{{ item.title }}
								</div>

							</div>
						</div>
						<div class="sub_1_btn" @click="handle_btn_to_index(3)">
							了解更多...
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- 	<div class="page1_main_layout" v-if="false">

		<div class="page1_show_title">
			<div class="page1_show_title_1">
				产品展示
			</div>
			<div class="page1_show_title_2">
				Product Display
			</div>
		</div>
		<div class="page1_show_menu_layout">
			<div class="page1_show_menu" >

				
				<div class="page1_show_menu_item" @click="choose_sub_menu(1)">
					<div class="page1_show_menu_item_active"></div>
					
					<div class="page1_show_menu_item_img page1_show_menu_item_img_1" id="menu_item_img_1"></div>
					<div class="page1_show_menu_item_text">
						AI接口
					</div>
				</div>
				
				<div class="page1_show_menu_item_line"></div>
				
				<div class="page1_show_menu_item" @click="choose_sub_menu(2)">
					<div class="page1_show_menu_item_img page1_show_menu_item_img_2" id="menu_item_img_2"></div>
					<div class="page1_show_menu_item_text">
						AI接口
					</div>
				</div>
				
				<div class="page1_show_menu_item_line"></div>
				
				<div class="page1_show_menu_item" @click="choose_sub_menu(3)">
					<div class="page1_show_menu_item_img page1_show_menu_item_img_3" id="menu_item_img_3"></div>
					<div class="page1_show_menu_item_text">
						AI接口
					</div>
				</div>
				
				<div class="page1_show_menu_item_line"></div>
				
				<div class="page1_show_menu_item" @click="choose_sub_menu(4)">
					<div class="page1_show_menu_item_img page1_show_menu_item_img_4" id="menu_item_img_4"></div>
					<div class="page1_show_menu_item_text">
						AI接口
					</div>
				</div>
				
				
			</div>
		</div>
		<div class="page1_show_content">
			<div class="page1_show_content_list">
				<div class="page1_show_content_item page1_show_content_1_item" v-for="i in 60" @click="click_one_btn('1_'+i)">
					<div class="page1_show_content_item_icon">
						
					</div>
					<div class="page1_show_content_item_title">
						AI处理
					</div>
					<div class="page1_show_content_item_text">
						1-{{i}} 测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测
					</div>
					
				</div>
			</div>
		</div>
		<div class="page1_show_content">
			<div class="page1_show_content_list">
				<div class="page1_show_content_item page1_show_content_2_item" v-for="i in 60">
					<div class="page1_show_content_item_icon">
						
					</div>
					<div class="page1_show_content_item_title">
						AI处理
					</div>
					<div class="page1_show_content_item_text">
						2-{{i}} 测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测
					</div>
				</div>
			</div>
		</div>
		<div class="page1_show_content">
			<div class="page1_show_content_list">
				<div class="page1_show_content_item page1_show_content_3_item" v-for="i in 60">
					<div class="page1_show_content_item_icon">
						
					</div>
					<div class="page1_show_content_item_title">
						AI处理
					</div>
					<div class="page1_show_content_item_text">
						3-{{i}} 测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测
					</div>
				</div>
			</div>
		</div>
		<div class="page1_show_content">
			<div class="page1_show_content_list">
				<div class="page1_show_content_item page1_show_content_4_item" v-for="i in 60">
					<div class="page1_show_content_item_icon">
						
					</div>
					<div class="page1_show_content_item_title">
						AI处理
					</div>
					<div class="page1_show_content_item_text">
						4-{{i}} 测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测
					</div>
				</div>
			</div>
		</div>
		<div class="page1_show_content">
			<div class="page1_show_content_list">
				<div class="page1_show_content_item page1_show_content_5_item" v-for="i in 60">
					<div class="page1_show_content_item_icon">
						
					</div>
					<div class="page1_show_content_item_title">
						AI处理
					</div>
					<div class="page1_show_content_item_text">
						5-{{i}} 测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测试测
					</div>
				</div>
			</div>
		</div>
		<div class="page1_show_pagination_layout">
			<el-pagination class="page1_show_pagination" 
				background 
				layout="prev, pager, next" 
				:total="pagination_total"
				@change="pagination_change"
				:default-page-size="pagination_page_size"
				v-model:current-page="pagination_current"
			/>

		</div>
		<div class="page1_show_content_2">
			
		</div>
		<div class="page1_carousel_layout">
			<el-carousel height="423px" trigger="click" motion-blur>
			    <el-carousel-item >
					<div class="page1_carousel_item" style="background-color: #6b8a9c;">
						1
					</div>
			    </el-carousel-item>
				<el-carousel-item >
				    <div class="page1_carousel_item" style="background-color: #7393a7;">
				    	2
				    </div>
				</el-carousel-item>
				<el-carousel-item >
				    <div class="page1_carousel_item" style="background-color: #637f90;">
				    	3
				    </div>
				</el-carousel-item>
				<el-carousel-item >
				    <div class="page1_carousel_item" style="background-color: #7798aa;">
				    	4
				    </div>
				</el-carousel-item>
			</el-carousel>
		</div>
	</div> -->
	<Footer></Footer>
</template>

<script>
import request from "@/utils/request";
import Footer from '@/components/Footer'

export default {
	name: "page1",
	components: {
		Footer
	},
	data() {
		return {
			base_url: SERVER_URL,
			sub_menu_index: 1,
			pagination_total: 60,
			pagination_page_size: 10,
			pagination_current: 1,
			page1_sub_index: 1,
			api_list_data: [],
			product_list_data_1: [],
			product_list_data_2: [],
			product_list_data_3: [],
			product_list_data_4: [],
		}
	},
	methods: {
		goto_contact() {
			let now_path = window.localStorage.getItem("main_path")
			if (now_path != "page6") {
				if (now_path.indexOf("page") != -1) {
					document.getElementById(now_path).className = "el-menu-item"
				}
				this.$router.push("/main/contact_information")
				window.localStorage.setItem("main_path", "page6");
				document.getElementById("page6").className = "el-menu-item is-active"
			}
		},
		goto_product() {
			let now_path = window.localStorage.getItem("main_path")
			if (now_path != "page2") {
				if (now_path.indexOf("page") != -1) {
					document.getElementById(now_path).className = "el-menu-item"
				}
				this.$router.push("/main/product_center")
				window.localStorage.setItem("main_path", "page2");
				document.getElementById("page2").className = "el-menu-item is-active"
			}
		},
		choose_app_item(ap_sub) {
			window.localStorage.setItem("ap_sub", ap_sub)
			this.$router.push("/main/industry_applications")
		},
		click_one_api_btn(item_id) {
			// console.log(item)
			window.localStorage.setItem("show_id", item_id);
			this.$router.push("/main/page_api_1")
		},
		show_one_product(id) {
			document.getElementById("page1").className = "el-menu-item"
			document.getElementById("page2").className = "el-menu-item is-active"

			window.localStorage.setItem("sub_path", id);
			window.localStorage.setItem("main_path", "show_product");
			this.$router.push("/main/show_product")
		},
		show_one_product_2(id) {
			document.getElementById("page1").className = "el-menu-item"
			document.getElementById("page3").className = "el-menu-item is-active"

			window.localStorage.setItem("sub_path", id);
			window.localStorage.setItem("main_path", "show_product");
			this.$router.push("/main/show_product")
		},
		handle_btn_to_index(index) {
			console.log(this.$route.path)
			if (index == 1) {
				let path = "page6"
				window.localStorage.setItem("main_path", path);
				document.getElementById(path).className = "el-menu-item is-active"
				document.getElementById("page1").className = "el-menu-item"
				this.$router.push("/main/" + path)
			} else if (index == 2) {
				let path = "page2"
				window.localStorage.setItem("main_path", path);
				document.getElementById(path).className = "el-menu-item is-active"
				document.getElementById("page1").className = "el-menu-item"
				this.$router.push("/main/" + path)
			} else if (index == 3) {
				let path = "page3"
				window.localStorage.setItem("main_path", path);
				document.getElementById(path).className = "el-menu-item is-active"
				document.getElementById("page1").className = "el-menu-item"
				this.$router.push("/main/" + path)
			}
		},
		handle_title_MouseOver(val) {
			if (val == 1) {
				this.page1_sub_index = 1
				// document.getElementsByClassName("page1_sub_1_title")[0].style.backgroundColor = "rgba(170, 170, 255, 0.4)"
				// document.getElementsByClassName("page1_sub_2_title")[0].style.backgroundColor = "rgba(85, 255, 255, 0.2)"
				// document.getElementsByClassName("page1_sub_3_title")[0].style.backgroundColor = "rgba(194, 194, 194, 0.2)"

				document.getElementsByClassName("page1_sub_2")[0].style.marginLeft = "calc(100vw - (100vw / 7.7) * 3 - 80px)"
				document.getElementsByClassName("page1_sub_3")[0].style.marginLeft = "calc(100vw - (100vw / 7.7) * 3 - 80px + (100vw / 7.7))"

				document.getElementsByClassName("sub_title_icon")[0].style.marginTop = "calc(((100vh - var(--main_header_height) - 100px - 70px)/2) + 40px )"
				document.getElementsByClassName("sub_title_icon")[1].style.marginTop = "calc(((100vh - var(--main_header_height) - 100px - 70px)/4)*3 )"
				document.getElementsByClassName("sub_title_icon")[2].style.marginTop = "calc(((100vh - var(--main_header_height) - 100px - 70px)/4)*3 )"

				document.getElementsByClassName("sub_title_content")[0].style.marginTop = "calc(((100vh - var(--main_header_height) - 100px - 70px)/2) - 40px )"
				document.getElementsByClassName("sub_title_content")[1].style.marginTop = "calc(((100vh - var(--main_header_height) - 100px - 70px)/4))"
				document.getElementsByClassName("sub_title_content")[2].style.marginTop = "calc(((100vh - var(--main_header_height) - 100px - 70px)/4))"

				setTimeout(function () {
					document.getElementsByClassName("sub_title_text")[0].style.display = "none"
					document.getElementsByClassName("sub_title_text")[1].style.display = ""
					document.getElementsByClassName("sub_title_text")[2].style.display = ""

					document.getElementsByClassName("sub_title_line")[0].style.display = ""
					document.getElementsByClassName("sub_title_line")[1].style.display = "none"
					document.getElementsByClassName("sub_title_line")[2].style.display = "none"
				}, 200)
			} else if (val == 2) {
				this.page1_sub_index = 2
				// document.getElementsByClassName("page1_sub_1_title")[0].style.backgroundColor = "rgba(0, 170, 255, 0.2)"
				// document.getElementsByClassName("page1_sub_2_title")[0].style.backgroundColor = "rgba(170, 170, 255, 0.4)"
				// document.getElementsByClassName("page1_sub_3_title")[0].style.backgroundColor = "rgba(194, 194, 194, 0.2)"

				document.getElementsByClassName("page1_sub_2")[0].style.marginLeft = "calc(100vw / 7.7)"
				document.getElementsByClassName("page1_sub_3")[0].style.marginLeft = "calc(100vw - (100vw / 7.7) * 3 - 80px + (100vw / 7.7))"


				document.getElementsByClassName("sub_title_icon")[1].style.marginTop = "calc(((100vh - var(--main_header_height) - 100px - 70px)/2) + 40px )"
				document.getElementsByClassName("sub_title_icon")[0].style.marginTop = "calc(((100vh - var(--main_header_height) - 100px - 70px)/4)*3 )"
				document.getElementsByClassName("sub_title_icon")[2].style.marginTop = "calc(((100vh - var(--main_header_height) - 100px - 70px)/4)*3 )"

				document.getElementsByClassName("sub_title_content")[1].style.marginTop = "calc(((100vh - var(--main_header_height) - 100px - 70px)/2) - 40px )"
				document.getElementsByClassName("sub_title_content")[0].style.marginTop = "calc(((100vh - var(--main_header_height) - 100px - 70px)/4))"
				document.getElementsByClassName("sub_title_content")[2].style.marginTop = "calc(((100vh - var(--main_header_height) - 100px - 70px)/4))"

				setTimeout(function () {
					document.getElementsByClassName("sub_title_text")[1].style.display = "none"
					document.getElementsByClassName("sub_title_text")[0].style.display = ""
					document.getElementsByClassName("sub_title_text")[2].style.display = ""

					document.getElementsByClassName("sub_title_line")[1].style.display = ""
					document.getElementsByClassName("sub_title_line")[0].style.display = "none"
					document.getElementsByClassName("sub_title_line")[2].style.display = "none"
				}, 200)
			} else if (val == 3) {
				this.page1_sub_index = 3
				// document.getElementsByClassName("page1_sub_1_title")[0].style.backgroundColor = "rgba(0, 170, 255, 0.2)"
				// document.getElementsByClassName("page1_sub_2_title")[0].style.backgroundColor = "rgba(85, 255, 255, 0.2)"
				// document.getElementsByClassName("page1_sub_3_title")[0].style.backgroundColor = "rgba(170, 170, 255, 0.4)"

				document.getElementsByClassName("page1_sub_2")[0].style.marginLeft = "calc(100vw / 7.7)"
				document.getElementsByClassName("page1_sub_3")[0].style.marginLeft = "calc((100vw / 7.7)*2)"



				document.getElementsByClassName("sub_title_icon")[2].style.marginTop = "calc(((100vh - var(--main_header_height) - 100px - 70px)/2) + 40px )"
				document.getElementsByClassName("sub_title_icon")[0].style.marginTop = "calc(((100vh - var(--main_header_height) - 100px - 70px)/4)*3 )"
				document.getElementsByClassName("sub_title_icon")[1].style.marginTop = "calc(((100vh - var(--main_header_height) - 100px - 70px)/4)*3 )"

				document.getElementsByClassName("sub_title_content")[2].style.marginTop = "calc(((100vh - var(--main_header_height) - 100px - 70px)/2) - 40px )"
				document.getElementsByClassName("sub_title_content")[0].style.marginTop = "calc(((100vh - var(--main_header_height) - 100px - 70px)/4))"
				document.getElementsByClassName("sub_title_content")[1].style.marginTop = "calc(((100vh - var(--main_header_height) - 100px - 70px)/4))"

				setTimeout(function () {
					document.getElementsByClassName("sub_title_text")[2].style.display = "none"
					document.getElementsByClassName("sub_title_text")[0].style.display = ""
					document.getElementsByClassName("sub_title_text")[1].style.display = ""

					document.getElementsByClassName("sub_title_line")[2].style.display = ""
					document.getElementsByClassName("sub_title_line")[0].style.display = "none"
					document.getElementsByClassName("sub_title_line")[1].style.display = "none"
				}, 200)
			}


		},
		click_one_btn(item) {
			// console.log(item)

			// document.getElementById("page3").className = "el-menu-item is-active"
			// document.getElementById("page1").className = "el-menu-item"

			window.localStorage.setItem("show_id", item.id);

			this.$router.push("/main/page_api_1")
		},
		pagination_change(currentPage, pageSize) {

			let class_name = "page1_show_content_" + this.sub_menu_index + "_item"
			let obj_arr = document.getElementsByClassName(class_name)
			// console.log(obj_arr)
			for (let i = 0; i < obj_arr.length; i++) {
				obj_arr[i].style.display = "none"
			}

			let max_index = currentPage * pageSize
			max_index = max_index > this.pagination_total ? this.pagination_total : max_index
			// console.log(max_index)
			// console.log((currentPage-1)*pageSize)
			for (let i = (currentPage - 1) * pageSize; i < max_index; i++) {
				obj_arr[i].style.display = "block"
			}
		},
		choose_sub_menu(val) {

			let old_index = this.sub_menu_index
			let class_name = "page1_show_menu_item_img page1_show_menu_item_img_" + old_index
			document.getElementById("menu_item_img_" + old_index).className = class_name
			document.getElementsByClassName("page1_show_menu_item_text")[old_index - 1].style.color = "#666"
			document.getElementsByClassName("page1_show_menu_item_active")[0].style.marginLeft = (240 * (old_index - 1)) + "px"

			this.sub_menu_index = val
			this.reload_sub_menu()

			this.pagination_current = 1
			this.pagination_change(1, this.pagination_page_size)
			if (val == 2) {
				this.pagination_total = 14
			} else if (val == 3) {
				this.pagination_total = 23
			} else if (val == 4) {
				this.pagination_total = 37
			} else if (val == 5) {
				this.pagination_total = 49
			} else {
				this.pagination_total = 60
			}
		},
		reload_sub_menu() {
			document.getElementsByClassName("page1_show_content")[0].style.display = "none"
			document.getElementsByClassName("page1_show_content")[1].style.display = "none"
			document.getElementsByClassName("page1_show_content")[2].style.display = "none"
			document.getElementsByClassName("page1_show_content")[3].style.display = "none"
			document.getElementsByClassName("page1_show_content")[4].style.display = "none"

			let new_index = this.sub_menu_index
			let class_name = "page1_show_menu_item_img page1_show_menu_item_img_" + new_index + "_choose"
			document.getElementById("menu_item_img_" + new_index).className = class_name
			document.getElementsByClassName("page1_show_menu_item_text")[new_index - 1].style.color = "#5590ff"
			document.getElementsByClassName("page1_show_menu_item_active")[0].style.marginLeft = (240 * (new_index - 1)) + "px"
			document.getElementsByClassName("page1_show_content")[new_index - 1].style.display = "block"

		},
		click_one_menu_phone(id, sub_id) {

			let phone_menu_is_show = window.localStorage.getItem("phone_menu")
			if (phone_menu_is_show == "true") {
				window.localStorage.setItem("phone_menu", false)
				document.getElementsByClassName("phone_menu_layout")[0].style.height = "0px";
				document.getElementsByClassName("menu_btn_phone")[0].style.transform = "rotate(60deg)";
			}

			let new_route = ""
			if (id == "page1") {
				new_route = "index"
			} else if (id == "page2") {
				new_route = "product_center"
			} else if (id == "page3") {
				new_route = "project_case"
			} else if (id == "page5") {
				new_route = "about_us"
			} else if (id == "page6") {
				new_route = "contact_information"
			}

			this.$GLOBAL.methods.init_header_menu(id)
			window.localStorage.setItem("main_path", id);
			window.localStorage.setItem("sub_id", sub_id);

			this.$router.push("/main/" + new_route)
		},
	},
	mounted() {

		document.getElementsByClassName("mainlayout_router_view")[0].scrollTop = 0

		this.api_list_data = this.$GLOBAL.api_list_data

		this.$GLOBAL.methods.init_header_menu("page1")

		this.api_list_data = this.$GLOBAL.api_list_data
		this.product_list_data_1 = this.$GLOBAL.product_list_data_1
		this.product_list_data_2 = this.$GLOBAL.product_list_data_2
		this.product_list_data_3 = this.$GLOBAL.product_list_data_3
		this.product_list_data_4 = this.$GLOBAL.product_list_data_4


		// request.get(this.$GLOBAL.flask_web_local_url+'/get_map_data_info').then(res => {
		// 	console.log(res)
		// })
		// document.getElementsByTagName('body')[0].style.setProperty('--menu_btn_color_1', 'rgba(85, 255, 255, 0.7)')
		// document.getElementsByTagName('body')[0].style.setProperty('--menu_btn_color_2', 'rgba(255, 255, 255, 0.4)')
		// document.getElementsByTagName('body')[0].style.setProperty('--menu_btn_color_3', 'rgba(255, 255, 255, 0.4)')
		// document.getElementsByTagName('body')[0].style.setProperty('--menu_btn_color_4', 'rgba(255, 255, 255, 0.4)')
		// document.getElementsByTagName('body')[0].style.setProperty('--menu_btn_color_5', 'rgba(255, 255, 255, 0.4)')
		// document.getElementsByTagName('body')[0].style.setProperty('--menu_btn_color_6', 'rgba(255, 255, 255, 0.4)')

		// this.reload_sub_menu();

		// this.choose_sub_menu(1)
		// this.pagination_change(1,this.pagination_page_size)

		setTimeout(function () {
			let item_list = document.getElementsByClassName("page_new_content_item")
			// console.log(item_list.length)
			for (let i = 0; i < item_list.length; i++) {
				if (i != 0 && (i + 1) % 5 == 0) {
					// item_list[i].style.marginRight = "0px"
					console.log(i)
				}
			}
			// document.getElementsByClassName("page_new_content_1")[0].style.display = ""
			// document.getElementsByClassName("page_new_content_1")[1].style.display = ""


		}, 50)

		window.localStorage.removeItem("sub_item_id");
	}
}
</script>

<style>
* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
	font-family: 'Segoe UI', 'Microsoft YaHei', sans-serif;
}

:root {
	--primary: #00f2fe;
	--secondary: #4facfe;
	--dark: #0f172a;
	--darker: #020617;
	--light: #e2e8f0;
	--accent: #7c3aed;
}

body {
	background-color: var(--dark);
	color: var(--light);
	line-height: 1.6;
}

.container {
	max-width: 1200px;
	/* height: 100vh; */
	margin: 0 auto;
	padding: 0 20px;
}

header {
	background-color: rgba(15, 23, 42, 0.9);
	backdrop-filter: blur(10px);
	position: fixed;
	width: 100%;
	top: 0;
	z-index: 1000;
	border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.header-content {
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 20px 0;
}

.logo {
	font-size: 24px;
	font-weight: 700;
	background: linear-gradient(to right, var(--primary), var(--secondary));
	-webkit-background-clip: text;
	background-clip: text;
	color: transparent;
}

nav ul {
	display: flex;
	list-style: none;
}

nav ul li {
	margin-left: 30px;
}

nav ul li a {
	text-decoration: none;
	color: var(--light);
	font-weight: 500;
	transition: color 0.3s;
	position: relative;
}

nav ul li a::after {
	content: '';
	position: absolute;
	width: 0;
	height: 2px;
	bottom: -5px;
	left: 0;
	background: linear-gradient(to right, var(--primary), var(--secondary));
	transition: width 0.3s;
}

nav ul li a:hover {
	color: var(--primary);
}

nav ul li a:hover::after {
	width: 100%;
}

.hero {
	height: calc(100vh - var(--main_header_height));
	display: flex;
	align-items: center;
	background-color: var(--darker);
	/* margin-top: 80px; */
	position: relative;
	overflow: hidden;
}

.hero::before {
	content: '';
	position: absolute;
	width: 100%;
	height: 100%;
	background: radial-gradient(circle at 30% 50%, rgba(124, 58, 237, 0.2), transparent 50%);
	z-index: 1;
}

.hero::after {
	content: '';
	position: absolute;
	width: 100%;
	height: 100%;
	background: radial-gradient(circle at 70% 50%, rgba(0, 242, 254, 0.2), transparent 50%);
	z-index: 1;
}

.hero-content {
	display: flex;
	align-items: center;
	justify-content: space-between;
	position: relative;
	z-index: 2;
}

.hero-text {
	flex: 1;
	padding-right: 50px;
	text-align: left;
}


.hero-text h1 {
	font-size: 48px !important;
	font-weight: 700 !important;
	margin-bottom: 20px;
	background: linear-gradient(to right, var(--primary), var(--secondary));
	-webkit-background-clip: text;
	background-clip: text;
	color: transparent;
}

.hero-text p {
	font-size: 18px;
	color: #94a3b8;
	margin-bottom: 30px;
}

.hero_btn_box {
	display: flex;
	align-items: center;
	gap: 15px;
}

.hero_btn_box_btn_1 {
	display: inline-block;
	background: linear-gradient(to right, var(--primary), var(--secondary));
	color: var(--darker);
	padding: 12px 30px;
	border-radius: 5px;
	text-decoration: none;
	font-weight: 600;
	transition: transform 0.3s, box-shadow 0.3s;
	position: relative;
	z-index: 1;
	overflow: hidden;
}

.hero_btn_box_btn_1::before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: linear-gradient(to right, var(--secondary), var(--primary));
	z-index: -1;
	opacity: 0;
	transition: opacity 0.3s;
}

.hero_btn_box_btn_1:hover {
	transform: translateY(-3px);
	box-shadow: 0 10px 20px rgba(0, 242, 254, 0.3);
}

.hero_btn_box_btn_1:hover::before {
	opacity: 1;
}

.hero-image {
	/* text-align: right; */
	/* flex: 1; */
	position: relative;
}

.hero-image .tech-circle {
	width: 400px;
	height: 400px;
	border-radius: 50%;
	background: linear-gradient(135deg, rgba(124, 58, 237, 0.1), rgba(0, 242, 254, 0.1));
	position: relative;
	display: flex;
	align-items: center;
	justify-content: center;
	animation: rotate 20s linear infinite;
}

@keyframes rotate {
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(360deg);
	}
}

.tech-circle::before {
	content: '';
	position: absolute;
	width: 100%;
	height: 100%;
	border-radius: 50%;
	border: 2px solid rgba(0, 242, 254, 0.3);
	box-sizing: border-box;
}

.tech-circle::after {
	content: '';
	position: absolute;
	width: 80%;
	height: 80%;
	border-radius: 50%;
	border: 2px dashed rgba(124, 58, 237, 0.3);
	box-sizing: border-box;
	animation: rotate-reverse 15s linear infinite;
}

@keyframes rotate-reverse {
	0% {
		transform: rotate(0deg);
	}

	100% {
		transform: rotate(-360deg);
	}
}

.tech-core {
	width: 150px;
	height: 150px;
	background: linear-gradient(135deg, var(--accent), var(--primary));
	border-radius: 50%;
	position: relative;
	z-index: 2;
	box-shadow: 0 0 30px rgba(0, 242, 254, 0.5);
}

.tech-core::before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	border-radius: 50%;
	background: linear-gradient(135deg, var(--primary), var(--accent));
	opacity: 0.7;
	filter: blur(10px);
}

.tech-dot {
	position: absolute;
	width: 20px;
	height: 20px;
	background-color: var(--primary);
	border-radius: 50%;
	box-shadow: 0 0 15px var(--primary);
}

.tech-dot:nth-child(1) {
	top: 50px;
	left: 20px;
}

.tech-dot:nth-child(2) {
	top: 100px;
	right: 30px;
}

.tech-dot:nth-child(3) {
	bottom: 60px;
	left: 50px;
}

.tech-dot:nth-child(4) {
	top: 30px;
	right: 100px;
}

.features {
	padding: 100px 0;
	background-color: var(--dark);
	position: relative;
	overflow: hidden;
}

.features::before {
	content: '';
	position: absolute;
	width: 300px;
	height: 300px;
	border-radius: 50%;
	background: radial-gradient(circle, rgba(124, 58, 237, 0.2), transparent 70%);
	top: -100px;
	left: -100px;
}

.features::after {
	content: '';
	position: absolute;
	width: 300px;
	height: 300px;
	border-radius: 50%;
	background: radial-gradient(circle, rgba(0, 242, 254, 0.2), transparent 70%);
	bottom: -100px;
	right: -100px;
}

.section-title {
	text-align: center;
	margin-bottom: 60px;
	position: relative;
	z-index: 2;
}

.section-title h2 {
	font-size: 36px;
	background: linear-gradient(to right, var(--primary), var(--secondary));
	-webkit-background-clip: text;
	background-clip: text;
	color: transparent;
	margin-bottom: 15px;
	display: inline-block;
}

.section-title p {
	color: #94a3b8;
	font-size: 18px;
}

.features-grid {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 30px;
	position: relative;
	z-index: 2;
}

.feature-card {
	background-color: rgba(15, 23, 42, 0.7);
	backdrop-filter: blur(10px);
	padding: 30px;
	border-radius: 10px;
	box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
	transition: transform 0.3s, box-shadow 0.3s;
	border: 1px solid rgba(255, 255, 255, 0.1);
	position: relative;
	overflow: hidden;
}

.feature-card::before {
	content: '';
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 3px;
	background: linear-gradient(to right, var(--primary), var(--secondary));
	transform: scaleX(0);
	transform-origin: left;
	transition: transform 0.5s;
}

.feature-card:hover {
	transform: translateY(-10px);
	box-shadow: 0 15px 30px rgba(0, 0, 0, 0.4);
}

.feature-card:hover::before {
	transform: scaleX(1);
}

.feature-icon {
	font-size: 40px;
	color: var(--primary);
	margin-bottom: 20px;
	position: relative;
}

.feature-icon::after {
	content: '';
	position: absolute;
	width: 50px;
	height: 50px;
	background: radial-gradient(circle, rgba(0, 242, 254, 0.2), transparent 70%);
	border-radius: 50%;
	top: -5px;
	left: -5px;
	z-index: -1;
}

.feature-card h3 {
	font-size: 22px;
	margin-bottom: 15px;
	color: var(--light);
}

.feature-card p {
	color: #94a3b8;
}

.cta {
	padding: 100px 0;
	background: linear-gradient(135deg, var(--darker), var(--dark));
	color: var(--light);
	text-align: center;
	position: relative;
	overflow: hidden;
}

.cta::before {
	content: '';
	position: absolute;
	width: 100%;
	height: 100%;
	background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%239C92AC' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
	opacity: 0.1;
}

.cta h2 {
	font-size: 36px;
	margin-bottom: 20px;
	background: linear-gradient(to right, var(--primary), var(--secondary));
	-webkit-background-clip: text;
	background-clip: text;
	color: transparent;
	display: inline-block;
}

.cta p {
	font-size: 18px;
	margin-bottom: 30px;
	max-width: 700px;
	margin-left: auto;
	margin-right: auto;
	color: #94a3b8;
}

.hero_btn_box_btn_2 {
	display: inline-block;
	background: transparent;
	color: var(--primary);
	padding: 12px 30px;
	border-radius: 5px;
	text-decoration: none;
	font-weight: 600;
	transition: background 0.3s, color 0.3s, transform 0.3s;
	border: 2px solid var(--primary);
}

.hero_btn_box_btn_2:hover {
	background: var(--primary);
	color: var(--darker);
	transform: translateY(-3px);
}

footer {
	background-color: var(--darker);
	color: var(--light);
	padding: 60px 0 30px;
	position: relative;
}

.footer-content {
	display: grid;
	grid-template-columns: repeat(4, 1fr);
	gap: 30px;
	margin-bottom: 40px;
}

.footer-column h3 {
	font-size: 18px;
	margin-bottom: 20px;
	color: var(--light);
	position: relative;
	display: inline-block;
}

.footer-column h3::after {
	content: '';
	position: absolute;
	width: 30px;
	height: 2px;
	background: linear-gradient(to right, var(--primary), var(--secondary));
	bottom: -8px;
	left: 0;
}

.footer-column ul {
	list-style: none;
}

.footer-column ul li {
	margin-bottom: 10px;
}

.footer-column ul li a {
	color: #94a3b8;
	text-decoration: none;
	transition: color 0.3s;
	position: relative;
	padding-left: 15px;
}

.footer-column ul li a::before {
	content: '';
	position: absolute;
	width: 6px;
	height: 6px;
	border-radius: 50%;
	background: var(--primary);
	left: 0;
	top: 50%;
	transform: translateY(-50%);
	opacity: 0.5;
	transition: opacity 0.3s;
}

.footer-column ul li a:hover {
	color: var(--primary);
}

.footer-column ul li a:hover::before {
	opacity: 1;
}

.copyright {
	text-align: center;
	padding-top: 30px;
	border-top: 1px solid rgba(255, 255, 255, 0.1);
	color: #64748b;
}

@media (max-width: 768px) {
	.hero-content {
		flex-direction: column;
	}

	.hero-text {
		padding-right: 0;
		margin-bottom: 40px;
		text-align: center;
	}

	.features-grid {
		grid-template-columns: 1fr;
	}

	.footer-content {
		grid-template-columns: 1fr 1fr;
	}
}

@media (max-width: 480px) {
	.header-content {
		flex-direction: column;
	}

	nav ul {
		margin-top: 20px;
	}

	nav ul li {
		margin-left: 15px;
		margin-right: 15px;
	}

	.hero-text h1 {
		font-size: 36px;
	}

	.footer-content {
		grid-template-columns: 1fr;
	}

	.hero_btn_box_btn_2 {
		margin-left: 0;
		margin-top: 15px;
		display: block;
		width: 80%;
		margin: 15px auto 0;
	}
}
</style>